<template>
   
        <v-app-bar
        class="rounded-0 pa-0 elevation-0"
    dense
      color="#ffff"
      fixed
      

    >
        <div v-if="isServices">
          <img
            alt="Navplus logo"
            class="logo-navplus navigatorlogo_desktop"
            :src="image"
          />
          <img
            alt="Navplus logo"
            style="width:2em"
            class=" navigatorlogo_mobile"
            :src="imagec"
          />
        </div>
        <div v-if="!isServices">
          <img
            alt="Navplus logo"
            class="logo-sailink sailinklogo_desktop "
            :src="imageb"
          />

          <img
            alt="Navplus logo"
            style="width:2em"
            class="sailinklogo_mobile "
            :src="imaged"
          />
          
        </div>
       
      
  
      <v-spacer></v-spacer>

      <v-btn v-if="!isHome"  to="/" color="#343A40" dark  small class="elevation-0 rounded-0 mr-2 homebtn_desktop">
        <v-icon class="mr-1" x-small>mdi-home</v-icon>
        Home
      </v-btn>

      <v-btn  v-if="isLoggedIn && isHome" to="/navigator+" color="#343A40" dark  small class="elevation-0 rounded-0 mr-2 dashboard_desktop">
        <v-icon class="mr-1" x-small>mdi-view-dashboard</v-icon>
        Dashboard
      </v-btn>

      <v-btn v-if="!isLoggedIn && !isLoginView" to="/login" color="#343A40" dark  small class="elevation-0 rounded-0 mr-2 loginbtn_desktop">
        <v-icon class="mr-1" x-small>mdi-login</v-icon>
       Login
      </v-btn>
      

    
      

      <v-menu v-if="isLoggedIn"
                    content-class="elevation-0 rounded-0 pa-0"
                    offset-y
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                      style="border: solid 1px #e0e0e0"
                        color="#F7F7F7"
                        v-bind="attrs"
                        v-on="on"
                        small
                        class=" elevation-0 rounded-0 pa-1 userbtn_mobile"
                      >
                        <v-icon x-small>mdi-menu</v-icon>
                      </v-btn>
                      <v-btn
                      style="border: solid 1px #e0e0e0"
                        color="#F7F7F7"
                        v-bind="attrs"
                        v-on="on"
                        small
                        class=" elevation-0 rounded-0 pa-1 userbtn_desktop"
                      >
                        <v-icon x-small>mdi-account</v-icon>
                        &nbsp; <v-text v-if="userprof">{{ userprof.name }}</v-text> 
                        <v-text v-else>{{ userName }}</v-text>
                        &nbsp;
                        <v-icon small>mdi-chevron-down</v-icon>
                      </v-btn>
                    </template>
                    <v-list
                      style="font-size: 0.9em;min-width:12em;border: solid 1px #E0E0E0;"
                      color="#ffff"
                      class="pa-1"
                    >
                    <v-list-item
                    v-if="userprof"
                     style="font-size:0.8em"
                     class="pa-0 ma-0 pl-1"
                    
                   >
                   {{ userAllowed.email }}
                   </v-list-item>
                    <v-divider v-if="userAllowed.email"></v-divider>
                      <v-list-item
                     
                        class="pa-0 ma-0 pl-1"
                        @click="editProfile_()"
                       
                      >
                        Edit Profile
                      </v-list-item>
                      <v-list-item
                      
                        class="pa-0 ma-0 pl-1"
                        @click="changePassword_()"
                      >
                        Change Password
                      </v-list-item>
                      <v-list-item
                    
                        class="pa-0 ma-0 pl-1"
                        @click="handleClick"
                      >
                        Logout
                      </v-list-item>
                    </v-list>
                  </v-menu>
      
      <!-- <v-btn small  class="elevation-0 rounded-0 ml-2" icon>
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn> -->

      <template style="border: solid 1px #E0E0E0;"  v-if="isServices" v-slot:extension>
        <v-tabs
        style="border-top: solid 1px #E0E0E0;"
        class="rounded-0 elevation-0"
        background-color="#F7F7F7"
        show-arrows
        left
        color="#174A8A"
       
      >
        <v-tabs-slider  color="#174A8A"></v-tabs-slider>
        
        <v-tab  to="/navigator+">Navigator+</v-tab>
        <v-tab to="/mysailink">My Sailink</v-tab>
        <v-tab to="/reports">Reports</v-tab>
        <v-tab to="/snapshot">Snapshot</v-tab>
        <v-tab to="/mythuraya">My Thuraya</v-tab>
        <v-tab to="/manifest">Manifest</v-tab>
        <v-tab v-if="!userAllowed.allowed['hide iot list']" to="/iot">Iot</v-tab>
        <v-tab v-if="userAllowed.role_id != 4" to="/admin">Admin</v-tab>
        <!-- <v-tab v-if="userAllowed.allowed['view crew list']" to="/crewwatch">Crew Watch</v-tab> -->
        <!-- <v-tab v-if="userAllowed.allowed['view summary']" to="/summary">Summary</v-tab> -->
      
      </v-tabs>
      </template>
      <EditProfileModal />
    <EditPassModal />
    <EditApiModal />
    
    </v-app-bar>

   

  </template>


<script>
import { mapGetters, mapActions } from "vuex";


import EditProfileModal from "@/components/modals/editprofile_modal.vue";
import EditPassModal from "@/components/modals/editpass_modal.vue";
import EditApiModal from "@/components/modals/apiaccess_modal.vue";

export default {
  name: "NavBar",
  props: ["user"],
  components: {
    EditProfileModal,
    EditPassModal,
    EditApiModal,
    // useOnline
  },
  data() {
    return {
      user_allowed:null,
      buka: null,
      image: require("@/assets/img/logo.svg"),
      imageb: require("@/assets/img/logo_sailink.svg"),
      imagec: require("@/assets/img/logo_mobile.svg"),
      imaged: require("@/assets/img/logo_sailink_mobile.svg"),
      services: false,
      home: true,
      account: false,
      ServiceisActive: false,
      HomeisActive: false,
      AccountisActive: false,
      navigator: true,
      mysailink: false,
      reports: false,
      mythuraya: false,
      manifest: false,
      iot: false,
      admin: false,
      userNames: localStorage.getItem("name"),
    };
  },



  methods: {
    ...mapActions([
      "setEditPass",
      "setEditProfile",
      "fetchUserData",
      "setEditPassID",
      "fetchEditPass",
      "fetchEditProf",
      "resetNavplusState",
      "resetMysailinkState",
      "resetMythurayaState",
      "resetReportState",
      "resetSnapshotState",
      "resetIotState",
      "resetManifestState",
      "resetAdminState"
    ]),

    editProfile_(){
      console.log('DI CLICK')
      var userallow =  JSON.parse(localStorage.getItem("user_data"))
     
      console.log(userallow)
      this.fetchEditProf(userallow.id)
    },

    changePassword_(){
      console.log('DI CLICK')
      var userallow =  JSON.parse(localStorage.getItem("user_data"))
      this.fetchEditPass(userallow.id)
     
    },
    redirectToHome() {
      this.$router.push({
        path: "/",
      });
    },
    redirectToDashboard() {
      this.$router.push({
        path: "/navigator+",
      });
    },
    redirectToLogin() {
      this.$router.push({
        path: "/login",
      });
    },
    
    toUpProf(user_id) {
      console.log("USER ID ==== " + user_id);
      this.$router.push({
        name: "editprofile",
        params: {
          user_id_bawaan: user_id,
        },
      });
    },
    toEditPass(user_id) {
      console.log("USER ID ==== " + user_id);
      this.$router.push({
        name: "changepassword",
        params: {
          user_id_bawaan: user_id,
        },
      });
    },
    handleClick() {
      this.resetNavplusState();
      this.resetMysailinkState();
      this.resetMythurayaState();
      this.resetReportState();
      this.resetSnapshotState();
      this.resetIotState();
      this.resetManifestState();
      this.resetAdminState();
      localStorage.removeItem("token");
      localStorage.removeItem("user_data");
      localStorage.setItem("name", "");
      localStorage.setItem("auth", false);
      this.$router.push("/login");
      window.location.reload();
      
    },
    serviceClick() {
      this.$router.push("/navplus/navplus");
    },
  },
  computed: {
    ...mapGetters([
      "userPass",
      "editprofile",
      "editpass",
      "userprof",
      "userData",
      "statusInternet",
      "Datauser"
    ]),

    isHome() {
      return this.$route.name === "home";
    },
    isServices() {
      return this.$route.name === "navigator+";
    },

    isLoginView() {
      return this.$route.name === "login";
    },

    isPrivacyView() {
      return this.$route.name == "privacy";
    },

    isServicesfirst() {
      return this.$route.path === "/navigator+";
    },

    isEditProfile() {
      return this.$route.path === "/editprofile";
    },

    isChangePw() {
      return this.$route.path === "/changepassword";
    },

    isHomefirst() {
      return this.$route.path !== "/" && "/sailink";
    },
    isLoggedIn() {
      return (
        localStorage.getItem("token") || this.$route.path === "/navigator+"
      );
    },
    userName() {
      return localStorage.getItem("name");
      // return this.userprof.user.name
    },
    userAllowed() {
      var userallow = localStorage.getItem("user_data")
      return JSON.parse(userallow)
    },
    userID() {
      return localStorage.getItem("iduser");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/navigationBar.scss";
.fixed-bar {
  position: sticky;
  position: -webkit-sticky; /* for Safari */
  top: 6em;
  z-index: 2;
}
.v-slide-group__content {
    /* display: flex; */
    flex: 1 0 auto;
    padding-left: 0.1em;
    position: relative;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    white-space: nowrap;
    border-bottom: solid 1px red;
}



@media (min-width: 280px) and (max-width: 319px) {
  .userbtn_mobile{
    display:block
  }
  .userbtn_desktop{
    display:none
  }

  .navigatorlogo_mobile{
    display:block
  }
  .navigatorlogo_desktop{
    display:none
  }

  .sailinklogo_mobile{
    display:block
  }

  .sailinklogo_desktop{
    display:none
  }
}

/* Mobile Devices */
@media (min-width: 320px) and (max-width: 480px) {
  .userbtn_mobile{
    display:block
  }
  .userbtn_desktop{
    display:none
  }

  .navigatorlogo_mobile{
    display:block
  }
  .navigatorlogo_desktop{
    display:none
  }

  .sailinklogo_mobile{
    display:block
  }

  .sailinklogo_desktop{
    display:none
  }
}

/* iPads, Tablets */
@media (min-width: 481px) and (max-width: 768px) {
  .userbtn_mobile{
    display:none
  }
  .userbtn_desktop{
    display:block
  }

  .navigatorlogo_mobile{
    display:none
  }
  .navigatorlogo_desktop{
    display:block
  }

  .sailinklogo_mobile{
    display:none
  }

  .sailinklogo_desktop{
    display:block
  }
}

/* Small screens, laptops */
@media (min-width: 769px) and (max-width: 1024px) {
  .userbtn_mobile{
    display:none
  }
  .userbtn_desktop{
    display:block
  }

  .navigatorlogo_mobile{
    display:none
  }
  .navigatorlogo_desktop{
    display:block
  }

  .sailinklogo_mobile{
    display:none
  }

  .sailinklogo_desktop{
    display:block
  }
}

/* Desktops, large screens */
@media (min-width: 1025px) and (max-width: 1200px){
  .userbtn_mobile{
    display:none
  }
  .userbtn_desktop{
    display:block
  }

  .navigatorlogo_mobile{
    display:none
  }
  .navigatorlogo_desktop{
    display:block
  }

  .sailinklogo_mobile{
    display:none
  }

  .sailinklogo_desktop{
    display:block
  }
}

/* Extra large screens / TV */
@media screen and (min-width: 1201px) {
  .userbtn_mobile{
    display:none
  }
  .userbtn_desktop{
    display:block
  }

  .navigatorlogo_mobile{
    display:none
  }
  .navigatorlogo_desktop{
    display:block
  }

  .sailinklogo_mobile{
    display:none
  }

  .sailinklogo_desktop{
    display:block
  }


}
</style>